import { render, staticRenderFns } from "./MarketingCompanyViewController.vue?vue&type=template&id=852ed66e"
import script from "./MarketingCompanyViewController.vue?vue&type=script&lang=js"
export * from "./MarketingCompanyViewController.vue?vue&type=script&lang=js"
import style0 from "./MarketingCompanyViewController.vue?vue&type=style&index=0&id=852ed66e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports